import React, { Fragment } from 'react';

import useGroupCompetitorListAttributes from './UseGroupCompetitorListAttributes';

import CompetitorListAttributesForm from '../../components/forms/CompetitorListAttributesForm';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GroupCompetitorListAttributes = () => {
  const {
    isLoading,
    isSaving,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onCancelClicked
  } = useGroupCompetitorListAttributes();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Competitor List Group Attributes</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <CompetitorListAttributesForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged} />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Cancel</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default GroupCompetitorListAttributes;